/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { task } from 'ember-concurrency';
import DS from 'ember-data';
import { tracked } from '@glimmer/tracking';

import AccountService from 'cio/services/account';
import AlertsService from 'cio/services/alerts';
import AnalyticsService from 'cio/services/analytics';

export default class Require2faControlsWrapper extends Component {
  @service account!: AccountService;
  @service alerts!: AlertsService;
  @service analytics!: AnalyticsService;
  @service store!: DS.Store;

  @tracked _showEnableModal = false;
  @tracked _showDisableModal = false;

  _enableTask = task(async () => {
    await this.account.current.enableTwoFactorAuthRequired({});
    await this.store.queryRecord('account', {}); // reload account model to reflect updated flag state
    this._showEnableModal = false;
    this.alerts.success(
      'twoFactorAuthRequiredEnable.success',
      'Two-factor authentication is now required for all team members!',
    );
  });

  _disableTask = task(async () => {
    await this.account.current.disableTwoFactorAuthRequired({});
    await this.store.queryRecord('account', {}); // reload account model to reflect updated flag state
    this._showDisableModal = false;
    this.alerts.success(
      'twoFactorAuthRequiredDisable.success',
      'Two-factor authentication is now optional for your account team members.',
    );
  });

  @action
  enableStart() {
    this.analytics.track('account', '2fa_required_enable_started');
    this._showEnableModal = true;
  }

  @action
  disableStart() {
    this.analytics.track('account', '2fa_required_disable_started');
    this._showDisableModal = true;
  }
}
